'use client';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 1050,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#F4A71C',
      light: '#F8C15D',
      dark: '#D18F19',
      contrastText: '#1C1C1C'
    },
    action: {
      selected: '#FFF5E0',
      disabledBackground: '#F4A71C'
    },
    secondary: {
      main: '#1C1C1C',
      light: '#ADADAD',
      dark: '#7C7C7C',
      contrastText: '#959595'
    },
    background: {
      default: '#f5f5f5'
    },
    yellow: {
      lightest: '#FFF5E0',
      light: '#FBD89F',
      main: '#F8C15D',
      dark: '#F4A71C'
    },
    success: {
      main: '#BDEAF2',
      light: '#BDEAF2',
      dark: '#BDEAF2',
      contrastText: '#1C1C1C'
    },
    info: {
      main: '#60a5fa',
      light: '#BDEAF2',
      contrastText: '#1C1C1C'
    }
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    // fontSize: 14,
    h1: {
      fontFamily: 'Scharf',
      fontSize: 32
    },
    h2: {
      fontFamily: 'Scharf',
      fontSize: 24
    },
    h3: {
      fontFamily: 'Scharf',
      fontSize: 20
    },
    h4: {
      fontFamily: 'Oswald-Regular',
      fontSize: 14
    },
    body1: {
      fontFamily: 'Droid Serif',
      fontSize: 16
    },
    button: {
      textTransform: 'none',
      fontFamily: 'Oswald-Regular'
    },
    caption: {
      fontFamily: 'Droid Serif',
      fontSize: 14,
      color: '#959595',
      lineHeight: 1.2
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        // h1: ({ theme }) => ({
        //   fontFamily: 'Scharf',
        //   fontWeight: 400,
        //   fontSize: '32px',
        //   lineHeight: '40px',
        //   [theme.breakpoints.down('sm')]: {
        //     fontSize: '24px'
        //   }
        // })
        // h2: ({ theme }) => ({
        //   fontFamily: 'Scharf',
        //   fontWeight: 500,
        //   fontSize: '24px',
        //   lineHeight: '32px',
        //   [theme.breakpoints.down('sm')]: {
        //     fontSize: '20px'
        //   }
        // }),
        // h3: ({ theme }) => ({
        //   fontFamily: 'Scharf',
        //   fontWeight: 500,
        //   fontSize: '20px',
        //   lineHeight: '32px',
        //   [theme.breakpoints.down('sm')]: {
        //     fontSize: '18px'
        //   }
        // }),
        // h4: () => ({
        //   fontFamily: 'Oswald-Regular',
        //   fontWeight: 500,
        //   fontSize: '14px'
        // }),
        // body1: () => ({
        //   fontFamily: 'Droid Serif',
        //   fontWeight: 400,
        //   fontSize: '16px',
        //   lineHeight: '24px'
        // })
      }
    },
    MuiCard: {
      defaultProps: {
        raised: true
      },
      styleOverrides: {
        root: {
          border: '1px solid #C5C5C5'
        }
      }
      //   styleOverrides: {
      //     root: ({ theme }) => ({
      //       borderRadius: 0,
      //       boxShadow: 'none',
      //       padding: '40px',
      //       display: 'flex',
      //       flexDirection: 'column',
      //       gap: 16,
      //       [theme.breakpoints.down('md')]: {
      //         padding: '30px'
      //       },
      //       [theme.breakpoints.down('sm')]: {
      //         padding: '20px'
      //       }
      //     })
      //   },
      //   variants: [
      //     {
      //       props: { variant: 'outlined' },
      //       style: {
      //         borderRadius: '6px',
      //         borderColor: '#959595'
      //       }
      //     },
      //     {
      //       props: { variant: 'outlined', color: 'secondary' },
      //       style: {
      //         gap: '25px',
      //         border: '2px solid var(--secondary-contrast-text, #f4a71c)',
      //         background: 'var(--Primary-Yellow-99, #fffdf7)'
      //       }
      //     }
      //   ]
    },
    MuiCardContent: {
      //   styleOverrides: {
      //     root: {
      //       padding: '0',
      //       display: 'flex',
      //       flexDirection: 'column',
      //       gap: '25px'
      //     }
      //   }
    },
    MuiCardActions: {
      //   styleOverrides: {
      //     root: {
      //       padding: '0',
      //       marginLeft: '0'
      //     }
      //   }
    },
    MuiDialogContent: {
      // Dirty fix to this issue:
      // https://github.com/mui/material-ui/issues/27851
      styleOverrides: {
        root: {
          paddingTop: '10px !important'
        }
      }
    },
    MuiDialogTitle: {
      //   styleOverrides: {
      //     root: {
      //       fontFamily: 'Scharf',
      //       padding: '0',
      //       marginLeft: '0',
      //       lineHeight: '28px',
      //       fontSize: '22px',
      //       fontWeight: '500'
      //     }
      //   }
    },
    MuiDialogActions: {
      //   styleOverrides: {
      //     root: {
      //       padding: '0',
      //       marginLeft: '0'
      //     }
      //   }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            opacity: 0.6
          }
        }
      },
      defaultProps: {
        size: 'large'
      }
      // styleOverrides: {
      //   root: () => ({
      //     textTransform: 'none',
      //     fontFamily: 'Oswald-Regular'
      //   })
      // }
    },
    MuiOutlinedInput: {
      //   styleOverrides: {
      //     notchedOutline: {
      //       borderColor: '#959595'
      //     }
      //   }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: ({ ownerState }) => {
          if (ownerState.focused) {
            return {
              '&.Mui-focused': {
                color: '#1C1C1C'
              }
            };
          }
          return {
            color: '#1C1C1C'
          };
        }
      }
    },
    MuiAlert: {
      //   styleOverrides: {
      //     root: {
      //       borderRadius: '8px'
      //     }
      //   }
    },
    MuiPaper: {
      //   styleOverrides: {
      //     root: {
      //       borderRadius: 0,
      //       padding: '20px',
      //       display: 'flex',
      //       flexDirection: 'column',
      //       gap: '25px'
      //       // borderColor: "var(--Secondary-Grey-80, #C5C5C5)",
      //     }
      //   }
    },
    MuiPopover: {
      //   styleOverrides: {
      //     paper: {
      //       borderRadius: 0,
      //       padding: '0px'
      //     }
      //   }
    },
    MuiDivider: {
      //   defaultProps: {
      //     variant: 'middle',
      //     sx: { borderColor: '#C5C5C5' }
      //   }
      //   styleOverrides: {
      //     root: {
      //       backgroundColor: '#C5C5C5',
      //       width: '100%'
      //     }
      //   }
    },
    MuiGrid: {
      defaultProps: {
        spacing: 3
      }
    },
    MuiGrid2: {
      defaultProps: {
        spacing: 3
      }
    },
    MuiStack: {
      defaultProps: {
        spacing: 3
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '.MuiInputLabel-root': {
            fontFamily: 'Oswald-Regular',
            fontSize: 14,
            textTransform: 'uppercase'
          },
          '.MuiInputBase-root': {
            fontFamily: 'Roboto, Arial, sans-serif'
          }
        }
      }
    }
  }
});

theme = responsiveFontSizes(theme);

export default theme;
